var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"right":"","max-height":"80vh"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"mr-3 text-hover hidden-md-and-up",attrs:{"x-large":""}},'v-icon',attrs,false),on),[_vm._v(" mdi-chevron-down ")])]}}])},[_c('v-list',[_c('v-expansion-panels',{attrs:{"accordion":"","flat":""}},[_vm._t("accordion-content")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }